import { Component, HostListener, OnInit, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { config, AnnouncementService, MemberQuery, MemberCard, MemberCardQuery, MemberDetails, BalanceQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  member: Signal<MemberDetails | undefined> = toSignal(this.memberQuery.selectMemberDetails());
  config = config;
  screenSize = ScreenType;
  name$: Observable<string>;
  card$: Observable<MemberCard | undefined>;
  loyaltyPointsCard$: Observable<number | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  showTopMenu: boolean = false;
  hasOffers: boolean = false;
  dsnIframeUrl: SafeResourceUrl;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    this.showTopMenu = scrollY > 210;
  }

  constructor(
    private announcementService: AnnouncementService,
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery,
    private balanceQuery: BalanceQuery,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {
    this.dsnIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://loyaltyid.suns.com/account/link-dsn');
  }

  ngOnInit() {
    this.name$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          return `${m.FirstName}`;
        }
        return '';
      })
    );
    this.announcementService.fetchAnnouncements().toPromise();
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.loyaltyPointsCard$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
  }

  onOffersData(data: any): void {
    this.hasOffers = !!(data?.Offers?.length || data?.Vouchers?.length);
  }

  navigateToWallet() {
    this.router.navigate(['/rewards/wallet']);
  }
}
